import { Wrapper } from '@klv/utils/wrapper';
import { Rive as RiveAtom } from '@klv/atoms/rive';

import * as styles from './styles/rive.module.scss';

import type { IRive } from './types';

export const Rive = ({
  backgroundColor,
  className = '',
  contained = false,
  inset = false,
  padded = false,
  fadeIn = false,
  customPadding = { customPaddingBottom: 'md', customPaddingTop: 'md' },
  ...props
}: IRive) => (
  <Wrapper
    className={className}
    fadeIn={fadeIn ? .25 : 0}
    grid={true}
    backgroundColor={backgroundColor}
    customPadding={customPadding}
    contained={contained}
    inlinePadding={padded}
  >
    <RiveAtom {...props} className={`${styles.rive} ${inset ? styles.inset : ''}`}/>
  </Wrapper>
);
